import React, { useState, useEffect } from "react";
import "./home.css";

const Home = () => {
  const [name, setName] = useState();

  useEffect(() => {
    const name = sessionStorage.getItem("userAlias");
    setName(name);
  }, []);

  return (
    <div className="homeBody">
      <div className="wlcome">
        <h1>Welcome {name}!</h1>
        <div className="photoWelcome"></div>
      </div>
    </div>
  );
};

export default Home;
